import { NavMenu } from '@shopify/app-bridge-react';
import { Link } from "react-router-dom";

const NavMenuList = () => {
    
    return (
        <NavMenu>
            <Link to="/" rel="home">Home</Link>
            <Link to="/admin/product_selection?select_tab=0">{`Product Selection`}</Link>
            <Link to="/admin/product_management?selectedView=0">{`Product Center`}</Link>
            <Link to="/admin/order_fulfillment?selectedView=0">{`Order Fulfillment`}</Link>
            <Link to="/admin/customService">{`Custom Service`}</Link>
            <Link to="/admin/plan_setting">{`Plan`}</Link>
            <Link to="/admin/settings">{`Settings`}</Link>
            <Link to="/admin/recommended-apps">{`Recommendation`}</Link>
        </NavMenu>
    );
}

export default NavMenuList;